import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "test" }
const _hoisted_2 = { class: "test-title" }
const _hoisted_3 = { class: "test-date" }
const _hoisted_4 = { class: "test-body" }
const _hoisted_5 = { class: "test-note" }

export function render(_ctx, _cache) {
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_col = _resolveComponent("el-col")
  const _component_Ticket = _resolveComponent("Ticket")
  const _component_Opportunity = _resolveComponent("Opportunity")
  const _component_Failed = _resolveComponent("Failed")
  const _component_el_row = _resolveComponent("el-row")
  const _component_EditPen = _resolveComponent("EditPen")
  const _component_Lock = _resolveComponent("Lock")
  const _component_Delete = _resolveComponent("Delete")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.model.name.substring(0,30) + (_ctx.model.name.length > 30 ? '...' : '')) + " ", 1),
      _createElementVNode("span", _hoisted_3, " am " + _toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.model.testdate))) + " um " + _toDisplayString(new Intl.DateTimeFormat('de-DE', {hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.model.testdate))), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            class: "left-side",
            span: 20
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "icon-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "icon-col",
                    title: "Anzahl registrierter Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserFilled)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "icon-col",
                    title: "Anzahl teilgenommener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Ticket)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "icon-col",
                    title: "Anzahl bestandener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Opportunity)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "icon-col",
                    title: "Anzahl durchgefallener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Failed)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { class: "text-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "text-col",
                    title: "Anzahl registrierter Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.count_registered), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "text-col",
                    title: "Anzahl teilgenommener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.count_redeemed), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "text-col",
                    title: "Anzahl bestandener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.count_passed), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    align: "center",
                    class: "text-col",
                    title: "Anzahl durchgefallener Prüflinge"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.count_failed), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "right-side",
            span: 4
          }, {
            default: _withCtx(() => [
              (_ctx.hasPermission['TEST_UPDATE'] || _ctx.hasPermission['TEST_QUESTION'])
                ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        class: "button-edit",
                        onClick: _ctx.onTestEditClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EditPen)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!(_ctx.hasPermission['TEST_UPDATE'] || _ctx.hasPermission['TEST_QUESTION']))
                ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { class: "button-inactive" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Lock)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasPermission['TEST_DELETE'])
                ? (_openBlock(), _createBlock(_component_el_row, { key: 2 }, {
                    default: _withCtx(() => [
                      (_ctx.hasPermission['TEST_DELETE'])
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            class: "button-delete",
                            onClick: _ctx.onTestDeleteClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 20 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.hasPermission['TEST_DELETE'])
                ? (_openBlock(), _createBlock(_component_el_row, { key: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { class: "button-inactive" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { size: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Lock)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.model.note.substring(0,200) + (_ctx.model.note.length > 200 ? '...' : '')), 1)
    ])
  ]))
}